jQuery(function ($) {
    // Newsletter subscription form handler
    const subscribeForm = $("#subscribe-form");
    let isSubmitting = false;
    
    if (subscribeForm.length) {
        const warningBox = subscribeForm.find(".footer-subscribe-warning-messages");
        const inputWrapper = subscribeForm.find(".footer-subscribe-input");
        const inputField = subscribeForm.find(".subscribe-input");
        const submitButton = subscribeForm.find('input[type="submit"]');
        const successMessage = $(".subscribe-form-success-submit");
        
        subscribeForm.on("submit", function (e) {
            e.preventDefault();
            
            // Prevent double submission
            if (isSubmitting) {
                return false;
            }
            
            const email = inputField.val().trim();
            
            // Basic client-side validation
            if (!email) {
                inputWrapper.addClass('input-warning');
                warningBox.show();
                return false;
            }
            
            // Email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                inputWrapper.addClass('input-warning');
                warningBox.show();
                return false;
            }
            
            // Check honeypot field (should be empty)
            const honeypot = subscribeForm.find('input[name="website"]').val();
            if (honeypot) {
                // Bot detected - silently fail
                return false;
            }
            
            // Disable form during submission
            isSubmitting = true;
            submitButton.prop('disabled', true);
            inputWrapper.removeClass('input-warning');
            warningBox.hide();
            
            // Show loading state
            const preloader = subscribeForm.find('.preloader');
            if (preloader.length) {
                preloader.addClass('preloader-visible');
            }
            
            // Prepare form data
            let formData = new FormData();
            formData.append('form-subscribe', email);
            formData.append('website', ''); // Honeypot
            
            // Inject CSRF token
            formData = window.CSRFHelper.injectCSRF(formData);
            
            // Submit via AJAX
            $.ajax({
                url: '/subscribe',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function(response) {
                    // Always update CSRF token first
                    window.CSRFHelper.updateCSRFMeta(response);
                    
                    if (response.success) {
                        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.track === 'function') {
                            window.CarBuyAnalytics.track('newsletter_signup', { form_location: 'footer' });
                        }
                        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.track === 'function') {
                            window.CarBuyMetaPixel.track('Lead', {
                                content_name: 'newsletter_signup',
                                content_category: 'newsletter',
                                form_location: 'footer'
                            });
                        }

                        // Hide form and show success message
                        subscribeForm.fadeOut(300, function() {
                            successMessage.removeClass('d-none').fadeIn(300);
                        });
                    } else {
                        // Show error message
                        if (response.message) {
                            warningBox.find('.footer-subscribe-input-message').text(response.message);
                        }
                        inputWrapper.addClass('input-warning');
                        warningBox.show();
                        
                        // Re-enable form
                        isSubmitting = false;
                        submitButton.prop('disabled', false);
                        if (preloader.length) {
                            preloader.removeClass('preloader-visible');
                        }
                    }
                },
                error: function(xhr, status, error) {
                    // Subscribe error
                    
                    // Try to update CSRF token
                    if (xhr.responseJSON && xhr.responseJSON.csrf_hash) {
                        window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                    }
                    
                    // Show error message
                    inputWrapper.addClass('input-warning');
                    warningBox.show();
                    
                    // Re-enable form
                    isSubmitting = false;
                    submitButton.prop('disabled', false);
                    if (preloader.length) {
                        preloader.removeClass('preloader-visible');
                    }
                }
            });
            
            return false;
        });
    }
});